import { Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import useUserOnlineHook from "../../helpers/hooks/useUserOnlineHook";

type props = {
  username?: string;
  className?: string;
};

const ConversationOnlineStatusComponent: React.FC<props> = ({ username, className }) => {
  const { t } = useTranslation();

  return (
    <Typography.Text className={className !== undefined ? className : "font-10-regular text-grey-color"}>
      {useUserOnlineHook(username) ? t("online") : t("offline")}
    </Typography.Text>
  );
};

export default ConversationOnlineStatusComponent;
